// extracted by mini-css-extract-plugin
module.exports = {"textarea":"TextArea-module__textarea___Hf6bM","focus":"TextArea-module__focus___102ul","error":"TextArea-module__error___2pbte"};